import React, { useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import AuthLayout from './auth/AuthLayout';
import { Banner, Field } from '../design/ui';

const ResetPassword = () => {
  const { t } = useTranslation();
  const { token } = useParams();
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [result, setResult] = useState(null); // { tone, text }
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmNewPassword) {
      setResult({ tone: 'danger', text: t('publicUi.passwordsDiffer', 'Les deux mots de passe ne correspondent pas.') });
      return;
    }
    setIsSubmitting(true);
    try {
      const response = await axios.post(`/api/auth/reset-password/${token}`, {
        new_password: newPassword,
      });
      setResult({ tone: 'success', text: response.data.message || t('publicUi.passwordChanged', 'Mot de passe changé. Vous pouvez vous connecter.') });
    } catch (error) {
      setResult({
        tone: 'danger',
        text: error.response && error.response.status === 400
          ? t('publicUi.resetFailedDetail', 'La réinitialisation a échoué : {{detail}}', { detail: error.response.data.detail })
          : t('publicUi.resetFailed', 'La réinitialisation a échoué. Le lien a peut-être expiré : refaites une demande.'),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthLayout
      heading={t('publicUi.resetTitle', 'Nouveau mot de passe')}
      subheading={t('publicUi.resetSub', 'Choisissez le mot de passe de votre compte Unanimity.')}
      footer={<a className="u-link" href="/"><ArrowLeft size={14} aria-hidden="true" /> {t('publicUi.backToSignIn', 'Retour à la connexion')}</a>}
    >
      <form className="u-form" onSubmit={handleResetPassword}>
        {result && <Banner tone={result.tone}>{result.text}</Banner>}
        <Field label={t('publicUi.newPassword', 'Nouveau mot de passe')} htmlFor="reset-new">
          <input id="reset-new" type="password" className="u-input" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} autoComplete="new-password" required />
        </Field>
        <Field label={t('publicUi.confirmPassword', 'Confirmer le mot de passe')} htmlFor="reset-confirm">
          <input id="reset-confirm" type="password" className="u-input" value={confirmNewPassword} onChange={(e) => setConfirmNewPassword(e.target.value)} autoComplete="new-password" required />
        </Field>
        <button type="submit" className="u-btn u-btn--primary u-btn--block" disabled={isSubmitting}>
          {isSubmitting ? t('common.loading', 'Chargement…') : t('publicUi.savePassword', 'Enregistrer le mot de passe')}
        </button>
      </form>
    </AuthLayout>
  );
};

export default ResetPassword;
